export var CssVariable;
(function (CssVariable) {
    CssVariable["borderRadius"] = "var(--x-border-radius)";
    CssVariable["colorBody"] = "var(--x-color-body)";
    CssVariable["colorLayer"] = "var(--x-color-layer)";
    CssVariable["colorSurface"] = "var(--x-color-surface)";
    CssVariable["colorPrimary"] = "var(--x-color-primary)";
    CssVariable["colorSecondary"] = "var(--x-color-secondary)";
    CssVariable["colorTextPrimary"] = "var(--x-color-text-primary)";
    CssVariable["inputHeight"] = "var(--XInput-height)";
    CssVariable["inputBorderRadius"] = "var(--XInput-border-radius)";
})(CssVariable || (CssVariable = {}));
